import { render, staticRenderFns } from "./ShopGoods.vue?vue&type=template&id=0a7fbc98&scoped=true"
import script from "./ShopGoods.vue?vue&type=script&lang=js"
export * from "./ShopGoods.vue?vue&type=script&lang=js"
import style0 from "./ShopGoods.vue?vue&type=style&index=0&id=0a7fbc98&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7fbc98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a7fbc98')) {
      api.createRecord('0a7fbc98', component.options)
    } else {
      api.reload('0a7fbc98', component.options)
    }
    module.hot.accept("./ShopGoods.vue?vue&type=template&id=0a7fbc98&scoped=true", function () {
      api.rerender('0a7fbc98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/dangao/shoplist/ShopGoods.vue"
export default component.exports